import React from 'react'
import { PlusIcon } from '@heroicons/react/24/outline'
import ContentFeedList from '../components/feeds/ContentFeedList'
import AccountList from '../components/account/AccountList'
import PageMasthead from '../components/PageMasthead'
import { useTitle } from '../components/TitleProvider'
import { useRecoilState } from 'recoil'
import { userState } from '../store/DomainStore'

const HomePage: React.FC = () => {
    useTitle('Home')
    const [user] = useRecoilState(userState)
    return (
        <div className="min-h-full bg-ink-50">
            <PageMasthead
                title="Home"
                subtitle="Your feeds and social profiles at a glance"
                actions={
                    <a
                        href={`#/account/new`}
                        className="inline-flex items-center gap-1 text-[13px] font-medium text-arwen-600 hover:text-arwen-800 hover:underline"
                    >
                        <PlusIcon className="h-4 w-4" aria-hidden="true" />
                        Add social profile
                    </a>
                }
            />
            <div className="flex flex-col gap-5 px-4 py-5 sm:px-6 lg:px-8">
                {user.feedsEnabled && <ContentFeedList />}
                <AccountList />
            </div>
        </div>
    )
}

export default HomePage
